import cn from 'classnames';
import countBy from 'lodash.countby';
import sortBy from 'lodash.sortby';
import PropTypes from 'prop-types';
import constants from '../../../../constants';

const KPI = ({ title, data = [], onClick, selected = false }) => {
	const statusCounts = Object.entries(countBy(data, 'request_status')).map(
		([status, count]) => ({ status, count }),
	);
	return (
		<div
			className={cn('relative', { 'cursor-pointer': onClick })}
			onClick={onClick}
		>
			<div
				className={cn(
					'p-4 bg-white border rounded-xl hover:z-20 hover:absolute hover:top-0 hover:left-0 hover:right-0 group',
					{ 'ring-2 ring-blue-500 border-blue-500': selected },
				)}
			>
				<div className="text-sm">{title}</div>
				<div className="mt-2 text-xl">
					<strong>{data.length}</strong>
				</div>
				{Object.keys(statusCounts).length > 1 && (
					<div className="hidden pt-2 group-hover:block">
						{sortBy(statusCounts, 'count')
							.reverse()
							.map(({ status, count }) => (
								<div key={status} className="flex gap-1 text-xs">
									<div>{count}</div>
									<div>{constants.status[status]}</div>
								</div>
							))}
					</div>
				)}
			</div>
		</div>
	);
};

KPI.propTypes = {
	title: PropTypes.string.isRequired,
	data: PropTypes.arrayOf(PropTypes.object),
	onClick: PropTypes.func,
	selected: PropTypes.bool,
};

export default KPI;
